import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('KARDEX', [
    'VIEW',
    'INFO',
    'HEADER',
    'EXPORT',
    'SUB_STOWAGE',
    'FILTER_FORM'
])
